import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { FilterModel } from "../../models/filter.model";
import { ErrorLabelConstants } from "../../constants/error-label.constants";
import { IAngularMyDpOptions } from "angular-mydatepicker";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import countryCodeToFlag from "country-code-to-flag";

declare var $: any;

@Component({
  selector: "app-advanced-search-bar",
  templateUrl: "./advanced-search-bar.component.html",
  styleUrls: ["./advanced-search-bar.component.scss"],
})
export class AdvancedSearchBarComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() filters: Array<FilterModel>;
  @Input() activeFilters: Array<FilterModel>;
  @Input() defaultFilter?: string;
  @Output() filterApplied: EventEmitter<FilterModel> = new EventEmitter();
  @Output() filterAppliedDownload: EventEmitter<FilterModel> = new EventEmitter();
  @Output() filterDeleted: EventEmitter<FilterModel> = new EventEmitter();

  countryCodeToFlag = countryCodeToFlag;
  form: FormGroup;
  formErrors: any;
  selectedFilter: FilterModel;

  doubleInput: boolean;

  datePickerOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: "dd/mm/yyyy",
    markCurrentDay: true,
    // other options...
  };
  subscription1: Subscription;
  subscription2: Subscription;

  constructor(public fb: FormBuilder, public translate: TranslateService) {}

  ngOnInit(): void {
    this.createForm();
    this.createFormErrors();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      $("#filters").on("loaded.bs.select", () => {
        this.initializeDefaultFilter();
      });
      $("#filters").selectpicker("refresh");
      $("#button_csv").popover({
        html:true,
        content: () => {
          return $('.popover-body-info-download-csv').html()
        }
      })
    }, 8);
  }

  // settiamo il filtro iniziale di default in base al tpo di ricerca
  initializeDefaultFilter() {
    for (let filter of this.filters) {
      if (filter.dtoField === this.defaultFilter) {
        this.selectedFilter = filter;
        break;
      }
    }
    setTimeout(() => {
      $("#filters").selectpicker("val", this.selectedFilter?.id);
    }, 0);
  }

  createForm() {
    for (let f of this.filters) {
      if (f.type === "select-text") {
        this.doubleInput = true;
      }
    }

    this.form = this.fb.group({
      filter: [this.filterApplied, [Validators.required]],
      input: ["", [Validators.required, Validators.pattern]],
    });

    if (this.doubleInput) {
      this.form.addControl("input1", new FormControl(""));
      this.form.addControl("input2", new FormControl(""));

      this.subscription2 = this.form
        ?.get("input2")
        .valueChanges.subscribe((val) => {
          if (val && this.form?.get("input1").value) {
            this.form
              ?.get("input")
              .setValue(
                this.form
                  ?.get("input1")
                  .value.concat("-" + this.form?.get("input2").value)
              );
            this.form.updateValueAndValidity();
          }
        });
      this.subscription1 = this.form
        ?.get("input1")
        .valueChanges.subscribe((val) => {
          if (val && this.form?.get("input2").value) {
            this.form
              ?.get("input")
              .setValue(
                this.form
                  ?.get("input1")
                  .value.concat("-" + this.form?.get("input2").value)
              );
            this.form.updateValueAndValidity();
          }
        });
    }

    // console.log(this.form);
  }

  createFormErrors(): void {
    this.formErrors = {
      filter: [ErrorLabelConstants.REQUIRED],
      input: [
        ErrorLabelConstants.REQUIRED,
        ErrorLabelConstants.PATTERN_INVALID,
      ],
      input1: [
        ErrorLabelConstants.REQUIRED,
        ErrorLabelConstants.PATTERN_INVALID,
      ],
      input2: [
        ErrorLabelConstants.REQUIRED,
        ErrorLabelConstants.PATTERN_INVALID,
      ],
    };
  }

  onFilterSelected(event) {
    for (let f of this.filters) {
      if (f.id == event) {
        this.selectedFilter = f;
      }
      this.form.get("input").reset();
      if (this.form.get("input1") && this.form.get("input2")) {
        this.form.get("input1").reset();
        this.form.get("input2").reset();
      }
    }

    // se il fltro non è double
    if (
      this.selectedFilter.type !== "select-text" &&
      this.form.get("input1") &&
      this.form.get("input2")
    ) {
      this.form.get("input1").clearValidators();
      this.form.get("input2").clearValidators();

      this.form.get("input").clearValidators();
      this.form
        .get("input")
        .setValidators([
          Validators.required,
          this.selectedFilter?.pattern
            ? Validators.pattern(this.selectedFilter?.pattern)
            : Validators.pattern(""),
        ]);
      this.form.get("input").updateValueAndValidity();

      this.form.get("input1").updateValueAndValidity();
      this.form.get("input2").updateValueAndValidity();
      console.log(this.form);
    }
    // se il fltro è di tipo doppio text
    if (this.doubleInput && this.selectedFilter.type === "select-text") {
      this.form.get("input").clearValidators();
      this.form.get("input").setValidators([Validators.required]);

      this.form.get("input1").setValidators([Validators.required]);
      this.form.get("input2").setValidators([Validators.required]);
      this.form.get("input").updateValueAndValidity();
      this.form.get("input1").updateValueAndValidity();
      this.form.get("input2").updateValueAndValidity();

      setTimeout(() => {
        $("#" + this.selectedFilter?.dtoField + "select-text1").selectpicker(
          "refresh"
        );
      }, 0);
    }

    // se il fltro è di tipo switch
    if (this.selectedFilter.dtoField === "suspendedOrders") {
      this.form.get("input").setValue(true);
      this.form.updateValueAndValidity();
    }
    // se il fltro è di tipo select
    if (this.selectedFilter.type === "select") {
      setTimeout(() => {
        $("#" + this.selectedFilter?.dtoField + "select").on(
          "loaded.bs.select",
          () => {
            $("#" + this.selectedFilter?.dtoField + "select").selectpicker(
              "val",
              ""
            );
          }
        );

        $("#" + this.selectedFilter?.dtoField + "select").selectpicker(
          "refresh"
        );
      }, 0);
    }
    // se il fltro è di tipo multi-select
    if (this.selectedFilter.type === "multi-select") {
      setTimeout(() => {
        $("#" + this.selectedFilter?.dtoField + "multi-select").on(
          "loaded.bs.select",
          () => {
            $("#" + this.selectedFilter?.dtoField + "select").selectpicker(
              "val",
              ""
            );
          }
        );

        $("#" + this.selectedFilter?.dtoField + "multi-select").selectpicker(
          "refresh"
        );
      }, 0);
    }
  }

  deleteFilter(f) {
    this.filterDeleted.emit(f);
  }

  onSearch() {
    this.selectedFilter.value = this.form.get("input").value;
    this.filterApplied.emit(this.selectedFilter);
  }

  onDownload() {
    this.selectedFilter.value = this.form.get("input").value;
    this.filterAppliedDownload.emit(this.selectedFilter);
  }


  ngOnDestroy(): void {
    if (this.subscription1 && this.subscription2) {
      this.subscription1.unsubscribe();
      this.subscription2.unsubscribe();
    }
  }
}
